import React from 'react';
import { Container, Box, Typography, Link, Divider, List, ListItem, ListItemText } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

const SectionHeading = ({ children }) => (
  <Typography variant="h5" component="h2" sx={{ mt: 6, mb: 2, fontWeight: 700 }}>
    {children}
  </Typography>
);

export default function DataPartnersPage() {
  return (
    <>
      <LandingPageNav />
      <Container maxWidth="md" sx={{ pt: { xs: 10, md: 12 }, pb: { xs: 6, md: 8 } }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
            Jet HomeLoans, LP Data Partners
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            At Jet HomeLoans, LP, we’re dedicated to giving you a seamless online mortgage experience. One way we do this is providing you the option to import your bank account and other information so that we can verify your financial info right in our app. Our official data partners help us to give you that experience so that you don’t have to send us documents the old-fashioned way.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            By using our digital app, you accept that we may share your information with these data partners so they can give us the insight we need into your finances and employment that’s needed for your loan application. The information we’ll share with our partners includes, but is not limited to, your full name, birth date, address, telephone number and social security number. With the help of our data partners, we’ll access your financial accounts to verify your financial assets and income, and we’ll access your employment information to verify your employment and income.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            To help us give you an experience that’s accurate and up-to-date, we may refresh your account information periodically while your loan is in process. If you close your mortgage with us, we may retain your information for up to 7 years after your last loan activity (for example: your last payment to us). If your application is withdrawn or denied, the amount of time that we retain your information will be less than that.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            You can change your consent preference at any time by calling 833-270-7191 or by submitting an Opt-Out request located here: <Link href="https://jethl.com/opt-out/" target="_blank" rel="noopener">jethl.com/opt-out/</Link>. When you do this, we will no longer access your account information, but we will keep the info that we’ve already collected as part of your loan record.
          </Typography>

          <SectionHeading>Jet HomeLoans, LP Data Partners include (but are not limited to):</SectionHeading>
          <List sx={{ mb: 4 }}>
            <ListItem disableGutters><ListItemText primary="SimpleNexus" /></ListItem>
            <ListItem disableGutters><ListItemText primary="Work Number" /></ListItem>
            <ListItem disableGutters><ListItemText primary="Certified Credit" /></ListItem>
            <ListItem disableGutters><ListItemText primary="Fannie Mae" /></ListItem>
            <ListItem disableGutters><ListItemText primary="Freddie Mac" /></ListItem>
            <ListItem disableGutters><ListItemText primary="Optimal Blue" /></ListItem>
          </List>

          <Divider sx={{ my: 5 }} />
          <Typography variant="body2" color="text.secondary">
            {/* Add a Last Updated date here if desired. */}
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
}
